import { createFileRoute } from '@tanstack/react-router';
import { Building2 } from 'lucide-react';
import { OrganizationsPage } from './index';

export const Route = createFileRoute(
  '/_authenticated/_layout/organizations/$orgId',
)({
  component: OrganizationsPage,
  staticData: {
    title: 'Organizations',
    icon: Building2,
  },
});
